import brand from '@helpers/brand';
import { fluidAdjusted } from '@helpers/fluid';
import { darken, lighten } from 'polished';
import styled from 'styled-components';
const activeModifyAmount = 0.05;
const Container = styled.button `
  font-family: var(--fontFamily);
  margin: 0;
  font-weight: 600;
  font-size: ${fluidAdjusted(16, 20)};
  line-height: ${fluidAdjusted(26, 36)};
  letter-spacing: -0.024em;
  height: max-content;
  max-height: 100%;
  width: max-content;
  max-width: 100%;
  text-decoration: none;
  padding: 6px 20px 10px;
  border-radius: 100px;
  cursor: pointer;
  transition: background-color lightenAmount5s ease-in-out, color lightenAmount5s ease-in-out;
  user-select: none;
  border: none;

  &[data-size='small'] {
    font-size: 13px;
    line-height: 20px;
    padding: 5px 17px 7px;
  }

  --bg: ${brand.grey.grey90}; // Set a default //
  --bgActive: ${lighten(activeModifyAmount, brand.grey.grey90)};
  --fg: ${brand.white};

  &:not([data-active]) {
    &[data-background='black'] {
      --bg: ${brand.black};
      --bgActive: ${lighten(activeModifyAmount, brand.black)};
    }
    &[data-background='red2'] {
      --bg: ${brand.secondary.red2};
      --bgActive: ${darken(activeModifyAmount, brand.secondary.red2)};
    }
    &[data-background='red4'] {
      --bg: ${brand.secondary.red4};
      --bgActive: ${lighten(activeModifyAmount, brand.secondary.red4)};
    }
    &[data-background='red5'] {
      --bg: ${brand.secondary.red5};
      --bgActive: ${lighten(activeModifyAmount, brand.secondary.red5)};
    }
    &[data-background='green'] {
      --bg: ${brand.tertiary.green};
      --bgActive: ${lighten(activeModifyAmount, brand.tertiary.green)};
    }
    &[data-background='buff4'] {
      --bg: ${brand.buff.buff4};
      --fg: ${brand.black};
      --bgActive: ${darken(activeModifyAmount, brand.buff.buff4)};
    }
    &[data-background='blue'] {
      --bg: ${brand.tertiary.blue};
      --bgActive: ${lighten(activeModifyAmount, brand.tertiary.blue)};
    }
    &[data-background='lightPurple'] {
      --bg: ${brand.tertiary.lightPurple};
      --bgActive: ${lighten(activeModifyAmount, brand.tertiary.lightPurple)};
    }
  }

  &[data-active='false'] {
    --fg: ${brand.black};
    --bg: ${brand.grey.grey90};
    --bgActive: ${lighten(activeModifyAmount, brand.grey.grey90)};
    font-weight: 300;
  }

  &[data-active='true'] {
    --fg: ${brand.white};
    --bg: ${brand.black};
    --bgActive: ${lighten(activeModifyAmount, brand.black)};
    font-weight: 700;
  }

  color: var(--fg);
  background-color: var(--bg);
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active {
    background-color: var(--bgActive);
  }

  &:focus {
    opacity: 0.7;
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
  }
`;
export const PillStyles = {
    Container,
};
